module.exports = __webpack_public_path__ + "static/media/cl.06dfe5ff.svg";